import qrcode from "qrcode-generator";

/**
 * The squares of a QR code for `text`, as rows of booleans (true = dark).
 * Error correction M: a Pix code is long, and a phone's camera is the reader.
 *
 * @param {string} text
 * @returns {boolean[][]}
 */
export const qrModules = (text) => {
    const qr = qrcode(0, "M");
    qr.addData(text);
    qr.make();
    const count = qr.getModuleCount();
    return Array.from({length: count}, (_, row) => Array.from({length: count}, (_, col) => qr.isDark(row, col)));
};
